module.exports = __webpack_public_path__ + "img/INTRO_ICON.b88ecd98.png";